
export default date => {
    const keys = new Array(31).fill(1).reduce((a, b, i) => ({ ...a, [`m${i + 1}`]: 0 }), {});
    return [
        {
            name: "Def. Group",
            sort: 0,
            ...keys
        }, {
            name: "Non-def. Group",
            sort: 1,
            ...keys
        }, {
            name: "GTD FIT",
            sort: 2,
            ...keys
        }, {
            name: "Non-gtd FIT",
            sort: 3,
            ...keys
        }, {
            name: "On-book总计",
            sort: 4,
            ...keys
        }, {
            name: "当日可售房量",
            sort: 5,
            ...keys
        }, {
            name: "住房率 %",
            sort: 6,
            ...keys
        }
    ].map(x => ({ ...x, code: x.name }))
}



// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.7/data.js